import { useEffect, useState } from "react";
import { Button, TextLink } from "@vds/buttons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { useMobileView } from "../../../hooks/useMobileView";

function CloudStepDownModal({
  opened = false,
  source = "Radio",
  onOpenedChange,
  onCancel,
  onSubmit,
  perkDetails,
}) {
  const isMobileView = useMobileView();
  const [isOpened, setOpened] = useState(opened);
  const [value, setValue] = useState("cloud-step-down-radioOne");
  const [individualDisplayPrice, setIndividualDisplayPrice] = useState("");
  const [groupDisplayPrice, setGroupDisplayPrice] = useState("");

  useEffect(() => {
    if (opened !== isOpened) {
      setOpened(opened);
    }
    setValue("cloud-step-down-radioOne");
  }, [opened]);

  useEffect(() => {
    try {
      const individualCloud = perkDetails?.find(p => p?.id === "R3552");
      const individualCurrentPrice = parseFloat(individualCloud?.price);
      const individualOriginalPrice = parseFloat(individualCloud?.perkOriginalPrice) - parseFloat(individualCloud?.chargePrice) + parseFloat(individualCloud?.price);
      setIndividualDisplayPrice(`$${individualCurrentPrice}/mo (a $${individualOriginalPrice} value)`);
      const groupCloud = perkDetails?.find(p => p?.id === "R3553");
      const groupCurrentPrice = parseFloat(groupCloud?.price);
      const groupOriginalPrice = parseFloat(groupCloud?.perkOriginalPrice) - parseFloat(groupCloud?.chargePrice) + parseFloat(groupCloud?.price);
      setGroupDisplayPrice(`$${groupCurrentPrice}/mo (a $${groupOriginalPrice} value)`);
    } catch (e) {
      console.error(e);
    }
  }, [perkDetails]);

  function handleOpened(opened) {
    try {
      setOpened(opened);
      onOpenedChange(opened);
    } catch (e) {
      console.error(e);
    }
  }

  function handleSubmit(e, isPrimary) {
    try {
      if (isPrimary && value === "cloud-step-down-radioOne") {
        onSubmit(value);
      } else {
        onCancel();
      }
    } catch (e) {
      console.error(e);
    }
    handleOpened(false);
  }

  return (
    <Modal
      className="CloudStepDownModal"
      closeButton={null}
      opened={isOpened}
      onOpenedChange={(opened) => handleOpened(opened)}
      surface="light"
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={true}
      ariaLabel="cloud-step-down-modal"
    >
      <ModalTitle>
        Wait, your cloud members could lose their storage.
      </ModalTitle>
      <ModalBody>
        <p>
          You currently have a Verizon Group subscription with up to 4 additional members. Before moving to an individual cloud plan, tell the members on your shared account to download everything they want to save. If they purchase their own cloud storage before you switch plans, their content automatically moves to their new plan. If they do not, they'll have 30 days to purchase a storage account and transfer their photos, videos and more.
        </p>
        <p>
          Please note if you move to Unlimited Individual Cloud Storage, only your content will move to your new account.
        </p>
        <RadioButtonGroup
          onChange={(e) => setValue(e?.target?.value)}
          error={false}
          data={[
            {
              name: "cloud-step-down-group",
              label: source === "Toggle"
                ? "Remove Unlimited Group Cloud Storage"
                : "Move to Unlimited Individual Cloud Storage",
              children: (
                <div>
                  <p>
                    {individualDisplayPrice}
                  </p>
                  <p>
                    {source === "Toggle"
                      ? "All members will lose their cloud content unless they open a new account within 30 days."
                      : "All members other than the account owner will lose their cloud content unless they open a new account within 30 days."
                    }
                  </p>
                </div>
              ),
              value: "cloud-step-down-radioOne",
              ariaLabel: "cloud-step-down-radio-one",
              disabled: false
            },
            {
              name: "cloud-step-down-group",
              label: "Keep Unlimited Group Cloud Storage",
              children: (
                <div>
                  <p>
                    {groupDisplayPrice}
                  </p>
                  <p>
                    All members keep the content in their group storage.
                  </p>
                </div>
              ),
              value: "cloud-step-down-radioTwo",
              ariaLabel: "cloud-step-down-radio-two",
            }
          ]}
        />
      </ModalBody>
      <ModalFooter>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignContent: "center",
            flexDirection: isMobileView ? "column" : "row",
            flexWrap: "wrap",
          }}>
          <Button
            display={isMobileView ? "block" : "inline-block"}
            size="large"
            disabled={false}
            use="primary"
            width={isMobileView ? "100%" : "auto"}
            onClick={e => handleSubmit(e, true)}
          >
            Got it
          </Button>
          <span
            style={{
              padding: "10px",
              width: isMobileView ? "100%" : "fit-content",
              textAlign: "center"
            }}
          >
            <TextLink
              type={isMobileView ? "standAlone" : "inline"}
              surface="light"
              disabled={false}
              onClick={e => handleSubmit(e, false)}
            >
              Cancel
            </TextLink>
          </span>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default CloudStepDownModal;
